import React from 'react'
import styles from './Description.module.scss'

export const Description = ({ text }) => (
  <div className={styles.descriptionContainer}>
    {text.map(({ title, paragraphs }, index) => (
      <div className={styles.section} key={index}>
        {title ? <div className={styles.title}>{title}</div> : null}
        {paragraphs.map((par, index) => (
          <p className={styles.paragraph} key={index}>
            {par}
          </p>
        ))}
      </div>
    ))}
  </div>
)
